import get from 'lodash/get';

export const getHostnameFromWindow = () => {
  return get(window, 'location.hostname', '');
};
